import { getAuthItem } from "./authStorage";

/** Match backend `normalizeRoleSlug` in `middleware/public/userAuth.js` */
export function normalizeRoleSlug(role) {
  return String(role ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getJwtRoleSlug(token) {
  const resolved = token ?? getAuthItem("jwt_token");
  const payload = decodeJwtPayload(resolved);
  return normalizeRoleSlug(payload?.role);
}

export function isTokenAllowedForRole(token, requiredRoleSlug) {
  if (requiredRoleSlug == null || String(requiredRoleSlug).trim() === "") {
    return true;
  }
  const tokenSlug = token ? getJwtRoleSlug(token) : "";
  const need = normalizeRoleSlug(requiredRoleSlug);
  return !!(token && tokenSlug && tokenSlug === need);
}
